import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";

// Mui
import { Box, RadioGroup, Skeleton, Stack } from "@mui/material";

// JDS
import { Button, Container, Notifications } from "@jds/core";

// Local
import SubSettingsHeader from "../../components/UI/SubSettingsHeader";
import PremiumImagePriceCard from "../../components/UI/Cards/PremiumImagePriceCard";
import useApiHttp from "../../hooks/use-http";
import Loader from "../../components/UI/Loader/Loader";
import EmptyState from "../../components/NoData/EmptyState";
import { useSelector } from "react-redux";

const planContainerStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(420px, 1fr))",
  gap: "16px",
  marginTop: "24px",
  maxHeight: "calc(100vh - 234px)",
  overflow: "auto",
  paddingBottom: "24px",
};

export default function PremiumImageCostPage() {
  const { id: eventId } = useParams();
  const navigate = useNavigate();
  const [eventDetails, setEventDetails] = useState();
  const [priceValue, setPriceValue] = useState("");
  const [planData, setPlanData] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState();
  console.log("hello123==>", selectedPlan);
  const { sendRequest: eventDetailApiRequest, isLoading } = useApiHttp();
  const { sendRequest: premiumPlanApiRequest, isLoading: planIsLoading } =
    useApiHttp();
  const {
    sendRequest: premiumImageCostUpdateRequest,
    isLoading: premiumImageCostUpdating,
  } = useApiHttp();

  const eventDetailApiHandler = () => {
    eventDetailApiRequest(
      {
        url: `event/get-event/${eventId}`,
      },
      () => {},
      (data) => {
        setEventDetails(data?.data);
        setPriceValue(data?.data?.priceId);
      }
    );
  };

  const premiumImageCostUpdateHandler = (planUUId, priceId, productId) => {
    const formData = new FormData();
    formData.append("id", eventId);
    formData.append("premiumImageCost", selectedPlan.prices[0].fixedPrice);
    formData.append("planUuid", selectedPlan.planUUID);
    formData.append("priceId", selectedPlan.prices[0].priceId);
    formData.append("productId", selectedPlan.productId);
    formData.append("planId", selectedPlan.planId);
    premiumImageCostUpdateRequest(
      {
        url: "event/update-premium-image-cost",
        method: "PATCH",
        body: formData,
        formData: true,
      },
      (data) => {},
      (data) => {
        Notifications.toast.success({
          id: "switch-approval",
          title: data?.message,
        });
      }
    );
  };

  useEffect(() => {
    eventDetailApiHandler();
    premiumPlanApiRequest(
      {
        url: "order/read-products",
      },
      () => {},
      (data) => {
        setPlanData(data.data);
      }
    );
  }, []);
  return (
    <div>
      <SubSettingsHeader heading="Premium Image Plans" />
      {planIsLoading ? (
        <Loader size="medium" />
      ) : planData.length > 0 ? (
        <>
          <RadioGroup
            name="use-radio-group"
            defaultValue="first"
            // sx={{ gap: "16px", mt: "24px" }}
            onChange={(e) => {
              setPriceValue(e.target.value);
            }}
            value={selectedPlan?.prices[0]?.priceId || eventDetails?.priceId}
            sx={planContainerStyle}
          >
            {planData.map((val, i) => {
              return (
                <PremiumImagePriceCard
                  key={val.planUUID}
                  controlLabelProps={{
                    value: val.prices[0].priceId,
                    onClick: () => setSelectedPlan(val),
                  }}
                  price={`${val?.prices[0].currencySymbol}${val?.prices[0].fixedPrice}`}
                  value={priceValue}
                  data={val}
                />
              );
            })}
          </RadioGroup>
          <Container
            horizontalAlign="end"
            style={{ margin: "24px 0", gap: "16px" }}
            fullWidth
          >
            <Button
              label="Back"
              size="large"
              kind="secondary"
              onClick={() => navigate(-1)}
            />

            <Button
              label="Save"
              size="large"
              disabled={!priceValue || !selectedPlan}
              loading={premiumImageCostUpdating}
              onClick={() => {
                premiumImageCostUpdateHandler();
              }}
            />
          </Container>
        </>
      ) : (
        <EmptyState
          title="No plans found!"
          action={false}
          style={{ marginTop: "32px" }}
        />
      )}
    </div>
  );
}
